import { useState } from "react";
import { Menu, ShoppingBag, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LangContext";
import { LANGS } from "@/lib/i18n";

const LINKS = ["courses", "webinars", "videos", "booking", "store", "contact"];

const LangSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center bg-parchment-200 rounded-full p-0.5 text-xs" data-testid="language-switcher">
      {LANGS.map((l) => (
        <button key={l.code} onClick={() => setLang(l.code)} data-testid={`lang-${l.code}`}
          className={`px-2.5 py-1.5 rounded-full transition-colors ${lang === l.code ? "bg-forest-800 text-parchment" : "text-forest-800 font-semibold hover:bg-parchment-300"}`}>
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default function Navbar({ hasVideos }) {
  const { count, setOpen } = useCart();
  const [menu, setMenu] = useState(false);
  const { t } = useLang();
  const links = hasVideos ? LINKS : LINKS.filter((l) => l !== "videos");

  return (
    <header className="sticky top-0 z-40 bg-parchment/85 backdrop-blur-lg border-b border-parchment-300" data-testid="site-header">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-baseline gap-1.5" data-testid="brand-logo">
          <span className="font-serif text-2xl font-bold text-forest-800">HithAyu</span>
          <span className="eyebrow hidden sm:inline">Wellness</span>
        </a>
        <nav className="hidden md:flex items-center gap-7 text-sm text-forest-800">
          {links.map((h) => (
            <a key={h} href={`#${h}`} className="hover:text-brass-700 transition-colors" data-testid={`nav-${h}`}>{t(`nav.${h}`)}</a>
          ))}
        </nav>
        <div className="flex items-center gap-1.5">
          <LangSwitch />
          <button onClick={() => setOpen(true)} className="relative p-2 rounded-full hover:bg-parchment-200 transition-colors" data-testid="cart-open-button" aria-label="Open cart">
            <ShoppingBag className="w-5 h-5 text-forest-800" />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 bg-brass-500 text-forest-900 text-[10px] font-bold rounded-full w-5 h-5 grid place-items-center" data-testid="cart-count">{count}</span>
            )}
          </button>
          <button onClick={() => setMenu(!menu)} className="md:hidden p-2 rounded-full hover:bg-parchment-200" data-testid="mobile-menu-toggle" aria-label="Menu">
            {menu ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {menu && (
        <nav className="md:hidden border-t border-parchment-300 bg-parchment px-5 py-3 flex flex-col" data-testid="mobile-menu">
          {links.map((h) => (
            <a key={h} href={`#${h}`} onClick={() => setMenu(false)} className="py-3 text-forest-800 border-b border-parchment-200 last:border-0" data-testid={`mobile-nav-${h}`}>{t(`nav.${h}`)}</a>
          ))}
        </nav>
      )}
    </header>
  );
}
